import React, { useState } from 'react';
import Dropdown from "./Dropdown.js";

const timeHourOptions = Array.from({ length: 24 }, (_, i) => {
  const hours = i.toString().padStart(2, '0');
  return { value: `${hours}`, label: `${hours}` };
});

const timeMinuteOptions = Array.from({ length: 60 }, (_, i) => {
  const minutes = i.toString().padStart(2, '0');
  return { value: `${minutes}`, label: `${minutes}` };
});


const TimeInput = ({ selectedHour, selectedMinute, onChangeHour, onChangeMinute }) => {
    return (
      <>
        <Dropdown
            options={timeHourOptions}
            value={timeHourOptions.find(option => option.value === selectedHour)}
            onChange={onChangeHour}
            placeholder="HH"
            isArrowshow={false}
        />
        <p className="mx-2 mb-0 fw-bold"> : </p>
        <Dropdown
            options={timeMinuteOptions}
            value={timeMinuteOptions.find(option => option.value === selectedMinute)}
            onChange={onChangeMinute}
            placeholder="MM"
            isArrowshow={false}
        />
      </>
    );
};

export default TimeInput;